var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SkeletonLoader',{staticClass:"list-display-loader"},[_c('div',{staticClass:"list-display-loader__content"}),_c('div',{staticClass:"list-display-loader__value"})])
}
var staticRenderFns = []

export { render, staticRenderFns }